import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  currentPage: number = 0;
  rowsPerPage: number = 5;

  constructor() { }

  setPage(page: number) {
    this.currentPage = page;
  }

  setRowsPerPage(rows: number) {
    this.rowsPerPage = rows;
  }
}
